import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOffOutlined";
import Divider from "@mui/material/Divider";
import PersonIcon from "@mui/icons-material/PersonOutline";
import { HttpStatusCode } from "axios";
import Alert from "@mui/material/Alert";
import SocialMediaLoginView from "./SocialMediaLoginView";
import { useSignInSignUp } from "../../context/SignInSignUpProvider";
import { axiosHttp } from "../../AxiosWrapper";
import { useAuthentication } from "../../context/AuthenticationProvider";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";

const SignInView = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [error, setError] = useState(false);

    const { logedInSuccess } = useAuthentication();
    const { signUp, userData, setUserData, clearUserData } = useSignInSignUp();

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const componentSize = isSmallScreen ? "small" :"medium";
    
    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
    }
    useEffect(() => {
        clearUserData()
    }, [])

    const handleSignIn = () => {
        if (!userData || userData.userName.trim() === "" || userData.password.trim() === "") {
            return;
        }
        setInProgress(true);
        axiosHttp.post("/api/pub/dss/v1/signIn", { userName: userData.userName, password: userData.password })
            .then((response) => {
                if (response.data.status === HttpStatusCode.Ok) {
                    logedInSuccess(response.data.content);
                } else {
                    setError(true);
                }
            })
            .catch((error) => { })
            .then((res) => {
                setInProgress(false);
            })
    }

    const styles = {
        label: {
            fontWeight: 600,
            mb: .5
        },
        text: {
            '& .MuiOutlinedInput-root': {
                borderRadius: 3,
                '& fieldset': {
                    borderRadius: 3,
                }
            },
            '& input:-webkit-autofill': {
                '-webkit-box-shadow': '0 0 0 1000px transparent inset',
                '-webkit-text-fill-color': 'black',
                transition: 'background-color 5000s ease-in-out 0s',
            },
        },
        socialLoginbtn: {
            p: 2,
            borderRadius: 2
        }
    }


    return (
        <Box>
            <Stack spacing={2}>
                <Box>
                    <Typography sx={styles.label}>Username</Typography>
                    <TextField fullWidth sx={styles.text}
                        size={componentSize}
                        type='text'
                        name="userName"
                        value={userData.userName}
                        onChange={onChangeInput}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end"><PersonIcon color="primary" fontSize={componentSize} /> </InputAdornment>
                                )
                            }
                        }}

                    />
                </Box>
                <Box>
                    <Typography sx={styles.label}>Password</Typography>
                    <TextField fullWidth sx={styles.text}
                        size={componentSize}
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        value={userData.password}
                        onChange={onChangeInput}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSignIn();
                            }
                        }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowPassword(!showPassword)}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onMouseUp={(e) => e.preventDefault()}
                                            edge="end"
                                            color="primary"
                                        >
                                            {showPassword ? <VisibilityIcon fontSize={componentSize} /> : <VisibilityOffIcon  fontSize={componentSize}/>}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }
                        }}

                    />
                </Box>
                    <Box sx={{ textAlign: 'right' }}>
                    <Typography onClick={()=>setUserData({...userData, state:"FORGOT_PASSWORD"})} component={Link} sx={{
                        position: "relative",
                        bottom: 10,
                        textDecoration: "none",
                        cursor:"pointer",
                        marginRight:0
                    }}>Forgot Password?</Typography>
                    </Box>


                {error && <Alert sx={{ borderRadius: 3 }} severity="error">Invalid Username or password!</Alert>}

                <Button loading={inProgress} onClick={handleSignIn} variant="contained" sx={{ py:{xs:.5, md:1.5},  borderRadius: 6 }}>Sign In</Button>
            </Stack>

            <Divider sx={{ my: 3 }}>or Sign in with</Divider>
            <SocialMediaLoginView/>
        
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: .5,
                mt: 1,
            }}>
                <Box sx={{
                    display: "flex",
                    flexDirection:{xs:"column",md:"row"},
                    alignItems: "center",
                    justifyContent: "center",
                    gap: .5,
                    mt: 1,
                }}>
                    <Typography sx={{ fontWeight: 600 }}>Don't have an account?</Typography>
                    <Typography sx={{ fontWeight: 600 }}><Link sx={{ fontWeight: 600, textDecoration: "none" }} onClick={signUp} component="button">Sign Up</Link> here.</Typography>
                    
                </Box>

            </Box>

        </Box>
    );
};

export default SignInView;